<template>
  <StackItemModal
      :dialog="{
        width: '550px'
      }"
      :sheet="{}"
      breakpoint="md"
      :actions="actions"
      :actionClose="false"
      v-bind="stackComponent.bind"
      v-on="listeners"
      title="Выберите способ оплаты"
  >

    <div class="q-mb-md">
      <OptionsCards
          :options="paymentTypesOptions"
          v-model="attrs.PAYMENT_TYPE"
          class="q-col-gutter-sm"
          optionClass="col-grow"
          optionIcon="ICON"
          optionLabel="NAME"
          optionValue="CODE"
          optionInnerClass="q-px-sm q-py-md full-height flex column items-center no-wrap"
          captionClass="s-font-2xs s-font-md-xs q-mt-xs"
          no-wrap
      />

      <div class="q-mt-lg">
        <div v-if="attrs.PAYMENT_TYPE === 'cash' && cashOptions.length">
          <div class="q-mb-sm">
            Сдача с:
          </div>
          <OptionsInline
              :full-width="true"
              v-model="attrs.CASH_SUM"
              :options="cashOptions"
              optionIcon="ICON"
              optionLabel="NAME"
              optionValue="VALUE"
              class="bg-white q-gutter-sm"
          />
        </div>
        <PaymentGiftInformer :cash-button-enabled="false" class="q-mt-sm"/>
      </div>

    </div>
  </StackItemModal>
</template>
<script setup lang="ts">
import {useStackComponent} from "@/packages/stack-router/hooks/useStackComponent";
import {useVorderDialog, VOrderDialogProps, vorderDialogPropsDefault} from "./hook";
import {computed, watch} from "vue";
import {MenuItem} from "@/gql/gen";
import {storeToRefs} from "pinia";
import getCashOptions from "@/core/util/getCashOptions";
import {useVorderTotalStore} from "@/modules/shop/store/vorder-total";
import OptionsCards from "@/components/Ui/OptionsCards.vue";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import PaymentGiftInformer from "@/components/Shop/VOrder/ui/Dialog/PaymentGiftInformer.vue";
import {useVorderPaymentGift} from "@/modules/shop/store/vorder-payment-gift";
import {useBus} from "@/core/store/bus";

const vorderState = useVorderState()
const vorderTotalStore = useVorderTotalStore()
const paymentGiftStore = useVorderPaymentGift()
const {attrs, paymentTypes} = storeToRefs(vorderState)
const {pricePay} = storeToRefs(vorderTotalStore)
const {syncPaymentGift} = paymentGiftStore

const {bus} = useBus()

const props = withDefaults(defineProps<VOrderDialogProps>(), {
  ...vorderDialogPropsDefault
})

const stackComponent = useStackComponent(props)

const {listeners} = useVorderDialog(props)

const actions = computed<Partial<MenuItem>[]>(() => {

  return [
    {
      label: props.fromSubmit ? 'Выбрать и оформить заказ' : 'Готово',
      onClick: () => {
        stackComponent.stackItem?.close()
        if (props.fromSubmit) {
          bus.emit('vorder:submit')
        }
      }
    }
  ]
})

const cashOptions = computed(() => {
  return getCashOptions(pricePay.value)
})

watch(
    () => [attrs.value.PAYMENT_TYPE, pricePay.value],
    () => syncPaymentGift(),
    {immediate: true}
)

const paymentTypesOptions = computed(() => paymentTypes.value.map(item => ({
  ...item,
  NAME: item.CODE === 'online' ? 'Онлайн' : item.NAME
})))

</script>
<style scoped>

</style>
